import React, { useEffect } from 'react';

const MessengerChat = () => {
  useEffect(() => {
    // Check if the fb-root div exists; if not, create it
    if (!document.getElementById('fb-root')) {
      const fbRoot = document.createElement('div');
      fbRoot.id = 'fb-root';
      document.body.appendChild(fbRoot);
    }

    // Check if the fb-customer-chat div exists; if not, create it
    if (!document.getElementById('fb-customer-chat')) {
      const chatDiv = document.createElement('div');
      chatDiv.id = 'fb-customer-chat';
      chatDiv.className = 'fb-customerchat';
      document.body.appendChild(chatDiv);
    }

    // Set the page ID for the Facebook Messenger chat
    const chatbox = document.getElementById('fb-customer-chat');
    console.log("chatbot", chatbox)
    if (chatbox) {
      chatbox.setAttribute('page_id', '382852214922184');  // Your Facebook Page ID
      chatbox.setAttribute('attribution', 'biz_inbox');
    }

    // Load the Facebook SDK asynchronously
    if (!document.getElementById('facebook-jssdk')) {
      window.fbAsyncInit = function () {
        window.FB.init({
          xfbml: true,
          version: 'v18.0',
        });
      };

      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
      document.body.appendChild(script);
    }
  }, []);

  return null; // Messenger chat is handled by the external script
};

export default MessengerChat;
